import getApiUrl from "../utils/getApiUrl";
import fetch from "../utils/mgFetch";

const getActiveUsersByDay = (
    token: string,
    backend: string,
    fromDate: string,
    toDate: string,
) => {
    return fetch(
        `${getApiUrl(backend)}active_users_by_day/${fromDate}/${toDate}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getActiveUsersByDay;